import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Categoria from "../views/Categoria";
import InfoProduct from "../views/InfoProduct";
import Login from "../views/Login";
import HomeProfile from "../views/HomeProfile";
import Sacola from "../views/Sacola";
import CheckOut from "../views/CheckOut";
import EsqueciSenha from "../views/EsqueciSenha";
import PoliticaPrivacidade from "../views/PoliticaPrivacidade";
import CadastrarUser from "../views/CadastrarUser"
import Manutencao from "../views/Manutencao";
import ResetPassword from "../views/ResetPassword";
import Compre from '../views/Compre';

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/reset-password/:token",
    name: "ResetPassword",
    component: ResetPassword
  },
  {
    path: "/manutencao",
    name: "Manutencao",
    component: Manutencao
  },
  {
    path: '/compre',
    name: "Compre",
    component: Compre
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    props: (route) => ({login: route.query.l})
  },
  {
    path: "/cadastrar",
    name: "Cadastro",
    component: CadastrarUser
  },
  {
    path: "/politica-privacidade",
    name: "Política de Privacidade",
    component: PoliticaPrivacidade,
  },
  {
    path: "/account",
    name: "HomeProfile",
    component: HomeProfile
  },
  {
    path: "/sacola",
    name: "Sacola",
    component: Sacola
  },
  {
    path: "/checkout",
    name: "Checkout",
    component: CheckOut
  },
  {
    path: "/esquecisenha",
    name: "EsqueciSenha",
    component: EsqueciSenha
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/:categoria",
    name: "Subcategoria",
    component: Categoria,
    props:(route) => ({sub : route.query.sub})
  },
  {
    path: "/:categoria",
    name: "Categoria",
    component: Categoria
  },
  {
    path: "/:nome_product/:codigo_produto",
    name: "Produto",
    component: InfoProduct
  },
  {
    path: "/search",
    name: "Search",
    component: Categoria
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;
